window.onJQueryLoad(function(){
	(function(){

		'use strict';

		//add a sticky class to social media
		jQuery(window).scroll(function() {
			if (jQuery(window).scrollTop() > 500) {
				jQuery('.social-media').addClass('sticky');
			} else {
				jQuery('.social-media').removeClass('sticky');
			}
		});

		//Insert Ink Chart Image before last Half And Half Layout
		jQuery('.inks-chart').insertBefore('.layout-full-width');

		jQuery('.trigger').on('click', function(){
			$('html, body').animate({scrollTop:540},1000);
		});

	})();
});
